var _defs, _rect, _rect2, _text, _text2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyfundraisingDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 520",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Easyfundraising donation banner",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f1f7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d7e7d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#08542d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2b6b3f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    rx: 32,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 720,
    height: 120,
    rx: 24,
    fill: "url(#bar)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 95,
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: 700
  }, "Donate via")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 150,
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 58,
    fontWeight: 800
  }, "easyfundraising")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 38,
    rx: 18,
    fill: "#ffffff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 26,
    fill: "#0e3d1f",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "Support Clipstone Miners Welfare Community Trust"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 280)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#25472f",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700
  }, "Shop with 8,000+ retailers"), /*#__PURE__*/React.createElement("text", {
    y: 40,
    fill: "#3a5d36",
    fontFamily: "Arial, sans-serif",
    fontSize: 20
  }, "and raise free donations for the Trust."))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 90,
    rx: 18,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 36,
    fill: "#0e3d1f",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "How it works"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 62,
    fill: "#3a5d36",
    fontFamily: "Arial, sans-serif",
    fontSize: 16
  }, "Start at the easyfundraising site,"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 82,
    fill: "#3a5d36",
    fontFamily: "Arial, sans-serif",
    fontSize: 16
  }, "shop as normal, and they donate to us."))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340, 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 90,
    rx: 18,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 38,
    fill: "#0e3d1f",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, "Search for"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 64,
    fill: "#3a5d36",
    fontFamily: "Arial, sans-serif",
    fontSize: 18
  }, "\"Clipstone Miners Welfare Community Trust\""))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyfundraisingDonate);
export default __webpack_public_path__ + "static/media/easyfundraising-donate.e853ef455e854fd09bd4ade53d550f17.svg";
export { ForwardRef as ReactComponent };